import PropTypes from "prop-types";
import { InputNumber } from "antd";
import { formatAmountInput, parseAmount } from "../../variables/numbersFunctions";

const normalizeFormatter = (formatter) => (value) => {
  if (value === undefined || value === null || value === "") {
    return "";
  }
  return formatter(value);
};

const normalizeParser = (parser) => (value) => {
  if (value === undefined || value === null || value === "") {
    return undefined;
  }
  return parser(value);
};

const AmountInputNumber = ({ formatter, parser, ...props }) => {
  const formatFn = normalizeFormatter(formatter ?? formatAmountInput);
  const parseFn = normalizeParser(parser ?? parseAmount);

  return <InputNumber {...props} formatter={formatFn} parser={parseFn} />;
};

AmountInputNumber.propTypes = {
  formatter: PropTypes.func,
  parser: PropTypes.func,
};

export default AmountInputNumber;
